export default __webpack_public_path__ + "static/media/aws.1a4ac1e0.webp";